/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataStates.vue?vue&type=template&id=58b86faa&scoped=true"
import script from "./dataStates.vue?vue&type=script&lang=js"
export * from "./dataStates.vue?vue&type=script&lang=js"
import style0 from "./dataStates.vue?vue&type=style&index=0&id=58b86faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b86faa",
  null
  
)

export default component.exports